import { Box } from "@mui/material";
import BottomNav from "../components/BottomNav";

export default function Layout({ children }) {
  return (
    <Box sx={{ pb: 8 }}>  {/* padding bottom for navigation bar */}
      {children}

      {/* Global Bottom Navigation */}
      <BottomNav />
    </Box>
  );
}
